import angular from 'angular';
import {FooterComponent} from './footer.component.js';

const footer = angular.module('footer', []);

footer.component('footer', FooterComponent);

export {footer};



// WEBPACK FOOTER //
// ./app/components/common/footer/footer.js